module.exports = __webpack_public_path__ + "img/ticks.e58ccea2.svg";